import PhoneNumber from 'awesome-phonenumber';

var formatPhoneNumber = function (phoneNumber, countryCode) {
    if (countryCode === void 0) { countryCode = 'US'; }
    if (!phoneNumber) {
        return '';
    }
    var pn = new PhoneNumber("".concat(phoneNumber), countryCode);
    return pn.getNumber('national');
};

export { formatPhoneNumber };
//# sourceMappingURL=formatPhoneNumber.js.map
